const vueInst = new Vue({
	el: '#vue-wrap',
	data: {
		bannerOption: {
			autoplay: true,
			loop: true,
			pagination: {
				el: '.swiper-pagination',
				clickable :true,
			},
		},
        teacherOption: {
            autoplay: {
                autoplay: true,
                delay: 0
            },
            speed: 6000,
            slidesPerView: 6
        },
		toolbarFlag: true,
		mid: null,
		mName: '',
		successFlag: false,
		bannerList: [],
		yijiList1: [],
		yijiList2: [],
        erjiList1: [],
        erjiList2: [],
        erjiList3: [],
        erjiList4: [],
        erjiList5: [],
        erjiList6: [],
        liveList: [],
		year: '',
		days: [],
        over: 0,
		testForm: {
			education: '',
			major_name: '',
			seniority: '',
			phone: '',
			phoneErr: '',
		},
        infoList: [],
        ad1: {},
		ad2: {},
        ad3: {},
        ad4: {},
        ad5: {},
        ad6: {},
		courseList: [],
		yearList: [2020, 2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012],
		dataList: [],
        teacherList: [],
		classList: [],
		videoInitFlag: false,
		leTvInst: null,
		playId: null,

        newLiveList:[],
	},
	methods: {
		openWin: function() {
            qimoChatClick();
		},
		getParams: function() {
            // this.mid = this.getQueryString('mid') - 0;

            let s = location.href.split('/');
            let p = s[s.length - 1];
			this.mid = p.split('.html')[0] - 0;
			switch (this.mid) {
				case 1:
					this.mName = '一级建造师';
					break;
				case 2:
					this.mName = '二级建造师';
					break;
				case 10:
					this.mName = '监理工程师';
					break;
				case 11:
					this.mName = '中级安全工程师';
					break;
				case 71:
					this.mName = '初级安全工程师';
					break;
				case 13:
					this.mName = '一级消防工程师';
					this.yearList = [2020, 2019, 2018, 2017, 2016, 2015];
					break;
                case 91:
                    this.mName = '二级消防工程师';
                    this.yearList = [2020, 2019, 2018, 2017, 2016, 2015];
                    break;
				case 64:
					this.mName = '初级经济师';
					break;
				case 65:
					this.mName = '中级经济师';
					break;
				case 67:
					this.mName = '一级造价工程师';
					break;
				case 70:
					this.mName = '二级造价工程师';
					break;
				case 68:
					this.mName = '初级会计师';
					break;
				case 69:
					this.mName = '中级会计师';
					break;
				default:
					break;
			}
		},
        getHome: function() {
            axios.post(baseURL + 'getMajorHome?mid=' + this.mid)
                .then(res => {
                    if (res.code == 200) {
                    	if (res.timeaddress && res.timeaddress[0]) {
                            // 考试时间
                            this.year = res.timeaddress[0].time_exam.substring(0, 4);

                            const reg = new RegExp( '-' , 'g' );
                            const startTime = new Date(res.timeaddress[0].time_exam.replace(reg, '/')).getTime();
                            const currentTime = new Date(res.currentime.replace(reg, '/')).getTime();

                            let days = '' + Math.ceil((startTime - currentTime) / 1000 / 60 / 60 / 24);
                            if (days < 0) {
                                this.over = 1
                            } else {
                                if (days < 10) {
                                    days = '00' + days;
                                } else if (days < 100) {
                                    days = '0' + days;
                                }
                            }
                            this.days = days.split('');
						}

                        res.imglist.forEach(item => {
                            if (item.type == 1) {
                                this.bannerList.push(item);
                            }
                            if (item.type == 2) {
                                this.ad1 = item;
                            }
                            if (item.type == 3) {
                                this.ad2 = item;
                            }
                            if (item.type == 4) {
                                this.ad3 = item;
                            }
                            if (item.type == 5) {
                                this.ad4 = item;
                            }
                            if (item.type == 6) {
                                this.ad5 = item;
                            }
                            if (item.type == 7) {
                                this.ad6 = item;
                            }
                        });

                        res.yjinfolist.forEach((item, index) => {
                            if (index < 5) this.yijiList1.push(item);
                            if (index > 4 && index < 10) this.yijiList2.push(item);
                        });

                        res.ejinfolist.forEach((item, index) => {
                            if (index < 5) this.erjiList1.push(item);
                            if (index > 4 && index < 10) this.erjiList2.push(item);
                            if (index > 9 && index < 15) this.erjiList3.push(item);
                            if (index > 14 && index < 20) this.erjiList4.push(item);
                            if (index > 19 && index < 25) this.erjiList5.push(item);
                            if (index > 24 && index < 30) this.erjiList6.push(item);
                        });

                        res.infotypelist.forEach(lItem => {
                            if (lItem.infolist) {
                                lItem.infolist.forEach(item => {
                                    item.thisdate = item.thisdate.split('-')[1] + '-' + item.thisdate.split('-')[2];
                                })
                            }
                        });
						this.infoList = res.infotypelist;

                        // 真题
                        this.courseList = res.courselist;

                        res.teacherlist.splice(10);
                        res.teacherlist.forEach((item, index) => {
                            item.isActive = index === 0;
                            item.class = item.course.split(/、|，|,/);
                        })
                        this.teacherList = res.teacherlist;
                    }
                })
                .catch(err => console.log(err));
        },
        getLive: function() {
            axios.post(baseURL + 'getAnnounce?page=1&rows=7&is_over=0&mid=' + this.mid)
                .then(res => {
                    if (res.code == 200) {
                        const reg = new RegExp( '-' , 'g' )

                        if (res.list[0] && new Date(res.list[0].start_time.replace(reg, '/')).getDate() == new Date(res.list[0].currentime.replace(reg, '/')).getDate()) {
                            res.list.forEach((item, index) => {
                                item.isActive = index === 0;
                                const startTime = new Date(item.start_time.replace(reg, '/'));
                                const currentTime = new Date(item.currentime.replace(reg, '/'));
                                const startDate = startTime.getDate();
                                const currentDate = currentTime.getDate();

                                item.start = startTime.getTime() - currentTime.getTime() < 0;

                                item.time = item.start_time.split(' ')[1].split(':')[0] + ':' + item.start_time.split(' ')[1].split(':')[1]

                                if (startDate == currentDate) {
                                    item.date = '今天'
                                } else if (startDate - currentDate > 0 && startDate - currentDate < 2) {
                                    item.date = '明天'
                                } else {
                                    item.date = item.start_time.split(' ')[0].split('-')[1] + '月' + item.start_time.split(' ')[0].split('-')[2] + '日 ' + this.getDay(startTime.getDay())
                                }
                            });
                            this.liveList = res.list;
                        }
                    }
                })
                .catch(err => console.log(err));
        },
        getNewList: function() {
            let formData = {
				page: 1,
                size: 8,
                subjectTypeId:null,
				type: 1,
			}
			request.post('/api/edu/teaching/video/recentLive', formData).then(res => {
                // console.log(res,'res')
				let list = res.data.records || [];
                let total = res.data.total;
                for (let i = 0; i < list.length; i++) {
                    let item = list[i];
                    item.isActive = i == 0;
                }
                this.newLiveList = list;
			})
        },
        goLive: function (item) {
            if(this.mid==11 || this.mid==71){
                window.open('pages/live/video.html?id=' + item.liveVideoId +'&structureId='+item.structureId);
            }else{
                window.open('pages/live/live.html?id=' + item.id);
            }
        },
        changeLive: function (live) {
            if(this.mid==11||this.mid==71){
                this.newLiveList.forEach(item => {
                    item.isActive = item.liveVideoId == live.liveVideoId;
                })
            }else{
                this.liveList.forEach(item => {
                    item.isActive = item.id == live.id;
                })
            }

        },
        testSubmit: function() {
            // 手机号验证
            if (!this.isPhoneNumber(this.testForm.phone)) {
                this.testForm.phoneErr = '请输入正确的手机号码!';
                return;
            }
            axios.post(baseURL + 'addGuestman?phone=' + this.testForm.phone
                + '&education=' + this.testForm.education
                + '&major_name=' + this.testForm.major_name
                + '&seniority=' + this.testForm.seniority
                + '&mid=' + this.mid
                + '&type=2')
                .then(res => {
                    if (res.code == 200) {
                        this.successFlag = true;
                        this.testForm = {
                            education: '',
                            major_name: '',
                            seniority: '',
                            phone: '',
                            phoneErr: '',
                        };
                    }
                    if (res.code == -1) {
                        alert(res.msg);
                    }
                })
                .catch(err => console.log(err));
        },
        getData: function() {
            let mid = this.mid;
            if (this.mid == 71) {
                mid = 11;
            }
            if (this.mid == 91) {
                mid = 13;
            }
            axios.post(baseURL + 'getMaterial?mid=' + mid + '&page=1&rows=30')
                .then(res => {
                    if (res.code == 200) {
                        this.dataList = res.list;
                    }
                })
                .catch(err => console.log(err));
        },
        goClassDetail: function(id, type) {
            window.open('pages/class/detail.html?type=' + type + '&id=' + id + '&mid=' + this.mid);
        },
        goTeacherDetail: function(id) {
            window.open('pages/teacher/detail.html?id=' + id);
        },
        changeTeacher: function(id) {
            this.teacherList.forEach(item => {
                item.isActive = item.id == id;
            })
        },
	},
	mounted: function () {
		this.getParams();
		this.getHome();
		this.getLive();
		this.getData();

        if(this.mid==11 || this.mid==71){
            this.getNewList()
        }
	}
});